import { c as _c } from "react/compiler-runtime";
import { LegacyIcon } from "@/components/shared/LegacyIcon";
import type { LegacyIconDefinition } from "@/components/shared/legacyIcons";
type LoginInputProps = {
  id: string;
  placeholder: string;
  value: string;
  onValueChange: (value: string) => void;
  icon: LegacyIconDefinition;
  type?: "text" | "password";
  isInvalid?: boolean;
};
export const LoginInput = t0 => {
  const $ = _c(15);
  const {
    id,
    placeholder,
    value,
    onValueChange,
    icon,
    type: t1,
    isInvalid: t2
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  const isInvalid = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== icon) {
    t3 = <LegacyIcon icon={icon} className="pointer-events-none absolute left-2.5 top-[11px] h-4 w-[14px] text-[#ccc]" />;
    $[0] = icon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onValueChange) {
    t4 = event => onValueChange(event.target.value);
    $[2] = onValueChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `h-[34px] w-full rounded border bg-white pl-[33px] pr-3 text-sm text-[#555] outline-none placeholder:text-[#999] focus:border-[#93a1bb] ${isInvalid ? "border-[#e73d4a]" : "border-[#c2cad8]"}`;
  let t6;
  if ($[4] !== id || $[5] !== isInvalid || $[6] !== placeholder || $[7] !== t4 || $[8] !== t5 || $[9] !== type || $[10] !== value) {
    t6 = <input id={id} name={id} type={type} autoComplete="off" placeholder={placeholder} aria-label={placeholder} aria-invalid={isInvalid} value={value} onChange={t4} className={t5} />;
    $[4] = id;
    $[5] = isInvalid;
    $[6] = placeholder;
    $[7] = t4;
    $[8] = t5;
    $[9] = type;
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="relative">{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};